const collection = document.querySelector('.js-collection');

if(collection) {
    collection.querySelectorAll('.js-promo-youtube').forEach(video => {
        const youtubeDiv = video.querySelector('div');
        const youtubeId = youtubeDiv.id.replace('VIDEO-', '');

        video.addEventListener('click', function handler() {

            if (typeof YT !== 'undefined') {
                video.classList.add('playing');
                video.removeEventListener('click', handler);

                const player = new YT.Player(youtubeDiv.id, {
                    videoId: youtubeId,
                    playerVars: {
                        autoplay: 1,
                        modestbranding: 1,
                        playsinline: 1,
                        rel: 0
                    }
                });

                setTimeout(() => {
                    player.playVideo();
                }, 1000);
            }
        });
    });
}
